// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import Tdg_TourItemSchema from './tdg-tour-item-schema';

const schema = {
  $id: '/post-pdf-request-schema',
  type: 'object',
  required: [],
  properties: {
    items: {
      type: 'array',
      nullable: true,
      items: { ...Tdg_TourItemSchema },
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
